/* istanbul ignore file @preserve */
import { ComponentsPropsList } from "@mui/material/styles/props";

export interface Localization {
  components?: {
    MuiAlert?: {
      defaultProps: Pick<ComponentsPropsList["MuiAlert"], "closeText">;
    };
    MuiBreadcrumbs?: {
      defaultProps: Pick<ComponentsPropsList["MuiBreadcrumbs"], "expandText">;
    };
    MuiTablePagination?: {
      defaultProps: Pick<
        ComponentsPropsList["MuiTablePagination"],
        "labelRowsPerPage" | "labelDisplayedRows" | "getItemAriaLabel"
      >;
    };
    MuiRating?: {
      defaultProps: Pick<
        ComponentsPropsList["MuiRating"],
        "emptyLabelText" | "getLabelText"
      >;
    };
    MuiAutocomplete?: {
      defaultProps: Pick<
        ComponentsPropsList["MuiAutocomplete"],
        "clearText" | "closeText" | "loadingText" | "noOptionsText" | "openText"
      >;
    };
    // The core package has no dependencies on the @mui/lab components.
    // We can't use ComponentsPropsList, we have to duplicate and inline the definitions.
    MuiPagination?: {
      defaultProps: Pick<
        ComponentsPropsList["MuiPagination"],
        "aria-label" | "getItemAriaLabel"
      >;
    };
  };
}

export const huHU: Localization = {
  components: {
    MuiBreadcrumbs: {
      defaultProps: {
        expandText: "Útvonal",
      },
    },
    MuiTablePagination: {
      defaultProps: {
        getItemAriaLabel: (type) => {
          if (type === "first") {
            return "Első oldalra";
          }
          if (type === "last") {
            return "Utolsó oldalra";
          }
          if (type === "next") {
            return "Következő oldalra";
          }
          // if (type === 'previous') {
          return "Előző oldalra";
        },
        labelRowsPerPage: "Sorok száma:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}–${to} / ${count !== -1 ? count : `több mint ${to}`}`,
      },
    },
    MuiRating: {
      defaultProps: {
        getLabelText: (value) => `${value} Csillag`,
        emptyLabelText: "Üres",
      },
    },
    MuiAutocomplete: {
      defaultProps: {
        clearText: "Törlés",
        closeText: "Bezárás",
        loadingText: "Töltés…",
        noOptionsText: "Nincs találat",
        openText: "Megnyitás",
      },
    },
    MuiAlert: {
      defaultProps: {
        closeText: "Bezárás",
      },
    },
    MuiPagination: {
      defaultProps: {
        "aria-label": "Lapozás",
        getItemAriaLabel: (type, page, selected) => {
          if (type === "page") {
            return `${page}. oldal${selected ? "" : "ra"}`;
          }
          if (type === "first") {
            return "Első oldalra";
          }
          if (type === "last") {
            return "Utolsó oldalra";
          }
          if (type === "next") {
            return "Következő oldalra";
          }
          // if (type === 'previous') {
          return "Előző oldalra";
        },
      },
    },
  },
};
